export function isAppRunningInE2EContext(): boolean {
  return sessionStorage.getItem('neptune_e2e_context') != null;
}
